import * as Colors from 'material-ui/styles/colors';

export default {
  underlineFocusStyle: {
    borderColor: Colors.green500
  }
};
